import { generateEntitiesColumns } from "../../../utils/entitiesColumns";
import { PERMISSION_MANAGE_QAM_ENTITIES } from "../../../components/_auth/permissions/permissions";
import { MODAL_QAM_ENTITY } from "./index";

export const TABLE_QAM_ENTITIES = "table-qam-entities";

export const generateColumns = (permission, dispatch, trans) =>
  generateEntitiesColumns({
    tableName: TABLE_QAM_ENTITIES,
    modalName: MODAL_QAM_ENTITY,
    permission,
    permissionConstant: PERMISSION_MANAGE_QAM_ENTITIES,
    actionsWidth: 80,
    dispatch,
    trans
  });
